import { render } from "./Form.vue?vue&type=template&id=59076dbe&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=59076dbe&scoped=true&lang=css"

import exportComponent from "C:\\dev-intelij\\MC-production\\widget-vuejs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59076dbe"]])

export default __exports__